<div class="report-filter-details-dialog">

    <div class="dialog-layout">

        <h2 class="dialog-h2">
            {{'filter definition' | translate: ['tmc-yard.widgets.report-filter-details-dialog.title',
            translationService.language]}}
        </h2>
        <i class="horizontal-divider"></i>

        <div class="top-info"></div>

        <div class="dialog-content" [formGroup]="filterDetailsFormGroup">

            <div class="report-timeframe">
                <h3>
                    {{'timeframe' | translate:['tmc-yard.widgets.report-filter-details-dialog.timeframe',
                    translationService.language]}}
                </h3>
                <div class="timeframe-selection">
                    <div class="timeframe-selection-layout">
                        <div class="timeframe-selection-options">
                            <mat-chip-list #chipList formControlName="timeframeType" name="timeframeType" selectable>
                                <mat-chip *ngFor="let o of reportFilterTimeframeTypeOptions" [selectable]="true"
                                    [removable]="false" [value]="o" (click)="onFilterTypeClicked(o)">
                                    {{o |
                                    translate:['tmc-yard.widgets.report-filter.timeframe-type-option.'+o,
                                    translationService.language]}}
                                </mat-chip>
                            </mat-chip-list>
                        </div>
                        <div class="timeframe-selection-datepicker">
                            <div class="timeframe-selection-datepicker-layout">
                                <mat-form-field class="day-field" *ngIf="dayVisible">
                                    <input matInput matInputInteger name="day" formControlName="day" required
                                        placeholder="{{'day' | translate: ['tmc-yard.widgets.report-filter-details-dialog.day', translationService.language]}}">
                                </mat-form-field>
                                <mat-form-field class="month-field" *ngIf="monthVisible">
                                    <mat-select name="month" formControlName="month" required
                                        placeholder="{{'month' | translate: ['tmc-yard.widgets.report-filter-details-dialog.month', translationService.language]}}">
                                        <mat-option [value]="1">
                                            {{'january' | translate:
                                            ['tmc-yard.widgets.report-filter-details-dialog.month.january',
                                            translationService.language]}}
                                        </mat-option>
                                        <mat-option [value]="2">
                                            {{'february' | translate:
                                            ['tmc-yard.widgets.report-filter-details-dialog.month.february',
                                            translationService.language]}}
                                        </mat-option>
                                        <mat-option [value]="3">
                                            {{'march' | translate:
                                            ['tmc-yard.widgets.report-filter-details-dialog.month.march',
                                            translationService.language]}}
                                        </mat-option>
                                        <mat-option [value]="4">
                                            {{'april' | translate:
                                            ['tmc-yard.widgets.report-filter-details-dialog.month.april',
                                            translationService.language]}}
                                        </mat-option>
                                        <mat-option [value]="5">
                                            {{'may' | translate:
                                            ['tmc-yard.widgets.report-filter-details-dialog.month.may',
                                            translationService.language]}}
                                        </mat-option>
                                        <mat-option [value]="6">
                                            {{'june' | translate:
                                            ['tmc-yard.widgets.report-filter-details-dialog.month.june',
                                            translationService.language]}}
                                        </mat-option>
                                        <mat-option [value]="7">
                                            {{'july' | translate:
                                            ['tmc-yard.widgets.report-filter-details-dialog.month.july',
                                            translationService.language]}}
                                        </mat-option>
                                        <mat-option [value]="8">
                                            {{'august' | translate:
                                            ['tmc-yard.widgets.report-filter-details-dialog.month.august',
                                            translationService.language]}}
                                        </mat-option>
                                        <mat-option [value]="9">
                                            {{'september' | translate:
                                            ['tmc-yard.widgets.report-filter-details-dialog.month.september',
                                            translationService.language]}}
                                        </mat-option>
                                        <mat-option [value]="10">
                                            {{'october' | translate:
                                            ['tmc-yard.widgets.report-filter-details-dialog.month.october',
                                            translationService.language]}}
                                        </mat-option>
                                        <mat-option [value]="11">
                                            {{'november' | translate:
                                            ['tmc-yard.widgets.report-filter-details-dialog.month.november',
                                            translationService.language]}}
                                        </mat-option>
                                        <mat-option [value]="12">
                                            {{'december' | translate:
                                            ['tmc-yard.widgets.report-filter-details-dialog.month.december',
                                            translationService.language]}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="year-field" *ngIf="yearVisible" required>
                                    <input matInput matInputInteger name="year" formControlName="year"
                                        placeholder="{{'year' | translate: ['tmc-yard.widgets.report-filter-details-dialog.year', translationService.language]}}">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="filter-selection">
                <h3>
                    {{'filter' | translate:['tmc-yard.widgets.report-filter-details-dialog.filter',
                    translationService.language]}}
                </h3>

                <mat-radio-group class="type-selection" formControlName="filterType" name="filterType">

                    <mat-radio-button [value]="reportFilterType.none">
                        {{'no filter' |
                        translate:['tmc-yard.widgets.report-filter-details-dialog.filter-type.no-filter',
                        translationService.language]}}
                    </mat-radio-button>

                    <mat-radio-button [value]="reportFilterType.options">
                        {{'transport options' |
                        translate:['tmc-yard.widgets.report-filter-details-dialog.filter-type.transport-options',
                        translationService.language]}}
                    </mat-radio-button>

                    <ng-container *ngIf="optionsFilterVisible">
                        <div class="transport-options">
                            <div class="form-box" *ngIf="optionsFilterVisible">
                                <div class="sections">
                                    <div class="section" *ngFor="let column of columns">
                                        <div class="options" *ngFor="let to of column.transportOptions">
                                            <mat-checkbox class="options-checkbox"
                                                [formControlName]="OPTIONS_FORM_PREFIX + to.id"
                                                name="{{OPTIONS_FORM_PREFIX + to.id}}">
                                                {{to.nameDictionaryKey | translate:[to.nameDictionaryKey,
                                                translationService.language]}}
                                            </mat-checkbox>

                                            <div class="child-options" *ngIf="this.filterModel.transportOptionIds.has(to.id)">
                                                <div *ngFor="let childOption of to.transportOptions">
                                                    <mat-checkbox class="options-checkbox"
                                                        [formControlName]="OPTIONS_FORM_PREFIX + childOption.id"
                                                        name="{{OPTIONS_FORM_PREFIX + childOption.id}}">
                                                        {{childOption.nameDictionaryKey |
                                                        translate:[childOption.nameDictionaryKey,
                                                        translationService.language]}}
                                                    </mat-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <mat-radio-button [value]="reportFilterType.structure">
                        {{'structure' |
                        translate:['tmc-yard.widgets.report-filter-details-dialog.filter-type.structure',
                        translationService.language]}}
                    </mat-radio-button>
                    <div [hidden]="!structureFilterVisible">
                        <app-structure-node-selection (selectedStructureChanged)="onSelectedStructureChanged($event)"
                            [selectedNode]="selectedStructureNode"></app-structure-node-selection>
                    </div>
                </mat-radio-group>
            </div>
        </div>

        <i class="horizontal-divider"></i>
        <div class="messages">

        </div>
        <div class="dialog-toolbar">
            <div class="left">
            </div>
            <div class="center">
            </div>
            <div class="right">
                <button class="cancel-button" mat-button (click)="cancelDialog()">
                    {{'cancel' |
                    translate:['tmc-yard.widgets.report-filter-details-dialog.action.cancel',
                    translationService.language]}}
                </button>
                <button class="confirm-button" mat-button (click)="confirmFilter()">
                    {{'confirm' |
                    translate:['tmc-yard.widgets.report-filter-details-dialog.action.confirm',
                    translationService.language]}}
                </button>
            </div>
        </div>
    </div>